import React, { Component } from 'react';
import NavBar from '../components/navbar';
import DescriptionCard from '../components/descriptionCard';
// import ProgressBar from '../components/progressBar'
import SideBar from '../components/sidebar1';
import CustomBtn from "../components/CustomBtn"
import TextField from '../components/textfield';

class Scope extends Component {
    constructor(props) {
        super(props);
        this.state = { jobDescription: '' }
    }

    handleSubmit = () => {
        console.log(this.state.jobDescription)
        fetch(process.env.REACT_APP_IP+'/desc', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "description": this.state.jobDescription
            })
        }).then((response) => response.json())
            .then((responseJson) => {
                console.log(responseJson)
                this.props.history.push({
                    pathname: "match",
                    state: { 
                        res: responseJson,
                        description: this.state.jobDescription
                    }
                  });
              
            });
    }
    componentDidMount() {
        const history = this.props.history
        console.log(history)
        if (history.location.state != null) {
            this.setState({
                jobDescription: history.location.state.description
            })
        }
    }

    handleChanges = (description) => {
        this.setState({ jobDescription: description });
    }

    render() {
        return (
            <div>
                <NavBar type="main"/>
                <div className="container">
                <div className="row justify-content-center" >
                    <div
                        className="col-lg-4 col-md-4 col-sm-12">
                        <SideBar stage={0}/>
                    </div>
                    <div className="col-lg-8 col-sm-12 col-md-8">
                        <div
                            className="row justify-content-center"
                            style={{ display: "grid", placeItems: "center" }}>
                            <div className="col">
                                <DescriptionCard
                                    description={this.state.jobDescription}
                                    handleChanges={this.handleChanges}
                                    click={this.handleSubmit}/>
                            </div>
                        </div>
                        <div className="row justify-content-center mb-5">
                            <TextField />
                        </div>
                        <div
                            className="row justify-content-center"
                            style={{ display: "grid", placeItems: "center" }}>
                                <CustomBtn  
                                type='secondary'
                                width='200%' 
                                fntSize='15px' 
                                colorwhite={false} 
                                txt='match'
                                onClick={this.handleSubmit}/>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        );
    }
}

export default Scope;